import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunedailycab() {



  const cardData =
  {
    keyword: ' Mumbai to Pune Daily Cab',
    heading: 'Sai Trupti Cabs: Mumbai to Pune Daily Cab',
    headingDescription: 'Sai Trupti Cabs provides dependable and convenient Mumbai to Pune daily cab services, tailored for travellers needing regular inter-city commuting or same-day return trips. Our fleet of well-maintained, air-conditioned Sedans, SUVs and Luxury cars offers comfort, cleanliness and punctuality for journeys between Mumbai and Pune. With experienced, background-verified drivers at your service 24×7, you receive professional assistance, timely pick-ups and safe travel throughout the route. Booking is easy, pricing is transparent (with no hidden charges for tolls or driver allowances), and you can opt for flexible one-way or round-trip scheduling. Choose Sai Trupti Cabs for stress-free, safe and efficient daily cab travel from Mumbai to Pune.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Mumbai to Pune Daily Cab",
      "description": "Reliable daily cab service from Mumbai to Pune offering comfortable rides, professional drivers, and hassle-free travel for business commuters, students, and daily travelers. Enjoy flexible scheduling, door-to-door pickup and drop, AC and non-AC options, well-maintained vehicles, real-time tracking, transparent fares, and excellent customer support for a stress-free and convenient daily journey."
    },
    {
      "name": "Mumbai to Pune Daily Taxi",
      "description": "Convenient daily taxi service from Mumbai to Pune with AC and non-AC vehicles, one-way or round trips, and professional drivers. Perfect for regular commuters, corporate employees, and students, offering punctual pickups, flexible timing, luggage assistance, safe and comfortable travel, and reliable point-to-point service ensuring a smooth daily commute."
    },
    {
      "name": "Mumbai to Pune Daily Car Hire",
      "description": "Daily car hire service from Mumbai to Pune providing a range of vehicles including Sedans, SUVs, and luxury cars. Ideal for long-term commuting, business travel, or group trips. Features include AC/non-AC options, professional drivers, flexible schedules, luggage support, online booking, transparent pricing, and reliable vehicles for safe, comfortable, and efficient daily transport."
    },
    {
      "name": "Mumbai to Pune Daily Innova Cab",
      "description": "Travel daily from Mumbai to Pune in a spacious Innova cab, perfect for families, groups, or corporate commuters. AC service, professional drivers, and comfortable seating ensure a smooth journey every day. Door-to-door service, luggage assistance, flexible scheduling, transparent fares, and real-time tracking make it an ideal choice for stress-free daily travel."
    },
    {
      "name": "Mumbai to Pune Daily Ertiga Cab",
      "description": "Daily Ertiga cab service from Mumbai to Pune providing comfortable seating for small groups or families, AC service, and professional drivers. Ideal for regular travel, airport transfers, or business commuting. Features include flexible pickup and drop points, luggage handling, transparent fares, well-maintained vehicles, and reliable, safe, and convenient daily transportation."
    },
    {
      "name": "Mumbai to Pune Daily Sedan Cab",
      "description": "Daily Sedan cab service from Mumbai to Pune offering a smooth, comfortable ride for solo travelers, couples, or small families. Professional drivers, AC/non-AC options, punctual pickups, door-to-door service, luggage assistance, transparent fares, and well-maintained vehicles ensure a safe, convenient, and relaxing daily commute."
    },
    {
      "name": "Mumbai to Pune Daily One Way Cab",
      "description": "Affordable one-way daily cab service from Mumbai to Pune for commuters seeking direct and efficient travel without waiting. AC and non-AC options, professional drivers, luggage handling, flexible pickup points, and reliable vehicles ensure a smooth and timely daily journey with maximum convenience and safety."
    },
    {
      "name": "Mumbai to Pune Daily Drop Cab",
      "description": "Daily drop cab service from Mumbai to Pune offering point-to-point travel with professional drivers, AC cars, and hassle-free service. Ideal for office commuters, students, and regular travelers. Features include door-to-door service, luggage assistance, flexible timing, transparent fares, well-maintained vehicles, and a safe, comfortable, and convenient daily ride."
    },
    {
      "name": "Mumbai to Pune Daily Luxury Cab",
      "description": "Premium daily luxury cab service from Mumbai to Pune with top-class vehicles, AC service, professional chauffeurs, and comfortable seating. Ideal for executives, VIP commuters, and travelers seeking elegance and convenience. Features include luggage handling, transparent fares, punctual pickups, door-to-door service, well-maintained cars, and a stress-free, smooth, and luxurious daily commute."
    },
    {
      "name": "Mumbai to Pune Daily Outstation Cab",
      "description": "Daily outstation cab service from Mumbai to Pune offering long-distance travel comfort with AC/non-AC vehicles, professional drivers, luggage assistance, tolls coverage, flexible scheduling, and well-maintained cars. Perfect for business trips, regular long-distance commuting, or group travel with a safe, reliable, and convenient daily journey."
    },
    {
      "name": "Affordable Mumbai to Pune Daily Cab",
      "description": "Budget-friendly daily cab service from Mumbai to Pune providing safe, reliable, and comfortable rides at cost-effective rates. AC/non-AC cars, professional drivers, door-to-door pickup, luggage support, flexible schedules, transparent fares, and well-maintained vehicles ensure daily commuting remains affordable without compromising on comfort and convenience."
    },
    {
      "name": "Mumbai to Pune Daily AC Cab",
      "description": "AC cab service for daily travel from Mumbai to Pune providing cool, comfortable, and safe rides for commuters, students, and business travelers. Features include professional drivers, well-maintained vehicles, flexible pickup and drop points, luggage assistance, transparent fares, punctual service, and reliable daily travel with a focus on comfort and convenience."
    },
    {
      "name": "Mumbai to Pune Daily Online Booking",
      "description": "Book Mumbai to Pune daily cabs online instantly with multiple vehicle options, secure payments, real-time tracking, and transparent fares. Suitable for regular commuters, office goers, students, and corporate travelers. AC/non-AC vehicles, professional drivers, door-to-door service, luggage assistance, and flexible scheduling ensure hassle-free, reliable, and convenient daily travel."
    },
    {
      "name": "Mumbai to Pune Daily Travel Service",
      "description": "Comprehensive daily travel service from Mumbai to Pune including cabs, one-way trips, drop services, and luxury travel options. Professional drivers, well-maintained vehicles, AC/non-AC options, luggage support, transparent fares, and flexible pickup/drop schedules ensure a smooth, safe, and comfortable daily commuting experience for business and personal travel."
    },
    {
      "name": "Mumbai to Pune Daily Cab Near Me",
      "description": "Find Mumbai to Pune daily cabs near your location for quick and convenient booking. Features include AC and non-AC vehicles, professional drivers, flexible pickup/drop points, luggage assistance, transparent fares, and reliable service. Perfect for office commuters, students, and regular travelers seeking safe, comfortable, and hassle-free daily transportation."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Daily Cab", "Mumbai to Pune Daily Taxi"],
    ["Mumbai to Pune Daily Car Hire", "Mumbai to Pune Daily Innova Cab"],
    ["Mumbai to Pune Daily Ertiga Cab", "Mumbai to Pune Daily Sedan Cab"],
    ["Mumbai to Pune Daily One Way Cab", "Mumbai to Pune Daily Drop Cab"],
    ["Mumbai to Pune Daily Luxury Cab", "Mumbai to Pune Daily Outstation Cab"],
    ["Affordable Mumbai to Pune Daily Cab", "Mumbai to Pune Daily AC Cab"],
    ["Mumbai to Pune Daily Online Booking", "Mumbai to Pune Daily Travel Service"],
    ["Mumbai to Pune Daily Cab Near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Pune Daily Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers dependable daily‑cab services from Mumbai to Pune—ideal for commute, business travel, airport transfers or regular city‑to‑city rides."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Fares for Mumbai to Pune daily trips start from approx. **₹11–₹20 per km** (sedans ~₹12/km, SUVs higher) with an additional driver allowance of ~₹300/day. :contentReference[oaicite:turn0search0]{index=1} :contentReference[oaicite:turn0search1]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo‑travellers and premium cars to suit your group‑size, luggage and comfort for the Mumbai → Pune route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Mumbai‑Pune expressway and daily‑route demands, ensuring a safe, smooth and punctual journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We handle convenient pickups across Mumbai (city, suburbs, airport) and drop‑offs anywhere in Pune (city, airport, suburbs) as per your schedule."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our cars are regularly serviced, sanitized and professionally managed to ensure comfort and reliability for a daily inter‑city commute."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, changes, or any travel assistance for your daily cab ride."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Mumbai to Pune daily cab easily via call, WhatsApp or our website—with instant confirmation and seamless vehicle dispatch."
  }
]


























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Mumbai to Pune daily cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Mumbai to Pune daily cab services, including one‑way, return and multi‑day trips.',
  },
  {
    question: 'How can I book a Mumbai to Pune daily cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Mumbai to Pune daily cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for Mumbai to Pune daily cab service?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cars to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Mumbai to Pune daily cab trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in inter‑city travel via the Mumbai–Pune Expressway, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can the Mumbai to Pune daily cab service be used for corporate travel or airport transfers?',
    answer: 'Certainly. Our daily cab services between Mumbai and Pune cater to corporate clients, airport transfers, meetings, and personal trips.',
  },
  {
    question: 'Is the Mumbai to Pune daily cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 daily cab services between Mumbai and Pune to match your schedule and travel flexibility.',
  },
  {
    question: 'What are the Mumbai to Pune daily cab fares?',
    answer: 'Our daily cab fares start from approximately ₹1,800‑₹2,000 for sedans, ₹2,500‑₹3,500 for SUVs and premium vehicles, depending on vehicle type, stay duration, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Mumbai to Pune daily cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and convenient transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Mumbai to Pune daily cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure your journey is safe and comfortable.',
  },
  {
    question: 'Is customer support available during the Mumbai to Pune daily cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Mumbai to Pune daily cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Sharma',
    feedback: 'I booked a Mumbai to Pune daily cab with Sai Trupti Cabs and the service was excellent. The driver was punctual and the car very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Gupta',
    feedback: 'Sai Trupti Cabs provided a smooth and hassle‑free daily cab service from Mumbai to Pune. Very professional and reliable.',
    rating: 5,
  },
];



































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Daily Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Mumbai to Pune Daily Cab with Sai Trupti Cabs for a safe, comfortable, and affordable daily commute. Choose AC sedans, SUVs, or Innova for daily travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-to-pune-daily-cab"
  }
};







  return (
    <div>
      <Helmet>
  <title>Mumbai to Pune Daily Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune Daily Cab with Sai Trupti Cabs for a safe, comfortable, and affordable daily commute. Choose AC sedans, SUVs, or Innova for daily travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Daily Cab, Mumbai to Pune Daily Taxi, Mumbai to Pune Daily Car Hire, Mumbai to Pune Daily Innova Cab, Mumbai to Pune Daily Ertiga Cab, Mumbai to Pune Daily Sedan Cab, Mumbai to Pune Daily One Way Cab, Mumbai to Pune Daily Drop Cab, Mumbai to Pune Daily Luxury Cab, Mumbai to Pune Daily Outstation Cab, Affordable Mumbai to Pune Daily Cab, Mumbai to Pune Daily AC Cab, Mumbai to Pune Daily Online Booking, Mumbai to Pune Daily Travel Service, Mumbai to Pune Daily Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newkey/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunedailycab;